import { render, staticRenderFns } from "./BasketWidget.vue?vue&type=template&id=0140f85e&"
import script from "./BasketWidget.vue?vue&type=script&lang=js&"
export * from "./BasketWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports